import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/common/services/data.service';
import { CommonserviceService } from '../../services/commonservice.service';

@Component({
  selector: 'app-float-profile-bar',
  templateUrl: './float-profile-bar.component.html',
  styleUrl : './float-profile-bar.component.css'
})
export class FloatProfileBarComponent implements OnInit, OnDestroy {


  @Input() userRoles: string = ''
  showLineDetails: boolean = false;
  // userRoles: string = '';
  currentUrl: string = ''; 
  role: string = '';
  private routerSubscription: Subscription;
  private userPreferencesSubscription: Subscription;
  isHovered = false;

  constructor(private readonly router: Router, private readonly userPreferenceService: DataService,
    private readonly commonService: CommonserviceService
  ) {}

  public showLine(): void {
    this.showLineDetails = !this.showLineDetails;
  }

  ngOnInit(): void {
    this.getRoles()
    this.loadUserPreferences();
    this.userPreferencesSubscription = this.userPreferenceService.getUserProfile().subscribe((response) => {
      if(response) {
        this.userRoles = this.joinValuesWithPipe({plant : response?.plantName, shop :  response?.shopName, line : response?.lineName});
      }
    });

    this.currentUrl = this.router.url;
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if( event.urlAfterRedirects !== '/home') {
          this.showLineDetails = false;
        }
        this.currentUrl = event.urlAfterRedirects;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.userPreferencesSubscription) {
      this.userPreferencesSubscription.unsubscribe();
    }
  }

  loadUserPreferences(): void {
    const savedPreferences = this.userPreferenceService.getUserPreferences();
    if (savedPreferences) {
      this.userRoles = this.joinValuesWithPipe(savedPreferences);
    }
  }

  joinValuesWithPipe(obj: { [key: string]: any }): string {
    const values = Object.values(obj).reduce((acc, val) => acc.concat(val), []);
    return values.join(' | ');
  }

  navigateToEditProfile(): void {
    this.router.navigate(['/edit-profile']);
  }

  private getRoles(): void {
    this.commonService.getRoles().subscribe({
      next: (response) => {
        this.role = response;
      },
      error: (error) => {
        console.error('getRoles Error:', error);
      }
    });
  }
}
